var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMergesplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.143555,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EAEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 17.43V9H13V17.43C13 17.78 13.18 18.11 13.49 18.29L17.67 20.8L16.68 23.14L13.27 23.43L15.86 25.67L15.07 29L18 27.23L20.93 29L20.15 25.67L22.74 23.43L19.33 23.14L18.34 20.8L22.52 18.29C22.82 18.11 23 17.79 23 17.43ZM19 19.23L18 19.83L17 19.23V10H19V19.23Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergesplit);
export default __webpack_public_path__ + "static/media/mergesplit.0c5c7c1691d889836f77a3ecf3044a66.svg";
export { ForwardRef as ReactComponent };